import styled from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';
import { VideoRenderer } from 'core';
import { videoFadeInAnimation } from 'ui/mixins';
import { BasePlaceholder, VideoLoadingOverlay } from '../view';

export { VideoLoadingOverlay as MobileVideoLoadingOverlay };

export const MobileSpeakerPlaceholder = styled(BasePlaceholder)`
    font-size: 32px;
    height: 40%;
    min-height: 80px;
    max-height: 150px;
    min-width: 80px;
    max-width: 150px;
`;

export const MobileViewerPlaceholder = styled(BasePlaceholder)`
    height: 40px;
    font-size: 14px;
`;

export const MobileSpeakerVideoRenderer = styled(VideoRenderer)<{
    $objectFit: string;
    $isReady?: boolean;
}>`
    height: 100%;
    width: 100%;
    ${({ $objectFit }) => ($objectFit ? `object-fit: ${$objectFit};` : null)}
    ${videoFadeInAnimation}
`;

export const MobileViewerVideoRenderer = styled(VideoRenderer)<{
    $objectFit: string;
    $isReady?: boolean;
}>`
    height: 100%;
    width: 100%;
    ${({ $objectFit }) => ($objectFit ? `object-fit: ${$objectFit};` : null)}
    ${videoFadeInAnimation}
`;

export const SIPCallIcon = styled(Icon)<{ $speaker?: boolean }>`
    --icon-color: ${(props) => props.theme.root.colors.basicColors.black['50%']};

    height: ${({ $speaker }) => ($speaker ? '48px' : '20px')} !important;
    width: ${({ $speaker }) => ($speaker ? '48px' : '20px')} !important;
`;
